import { render, staticRenderFns } from "./FileProcessor.vue?vue&type=template&id=b5d8f7b2&scoped=true"
import script from "./FileProcessor.vue?vue&type=script&lang=js"
export * from "./FileProcessor.vue?vue&type=script&lang=js"
import style0 from "./FileProcessor.vue?vue&type=style&index=0&id=b5d8f7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d8f7b2",
  null
  
)

export default component.exports